import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimulatorCardComponent } from './components/simulator-card/simulator-card.component';
import { PillButtonComponent } from './components/pill-button/pill-button.component';
import { BrandAssetPipe } from './pipes/brand-asset.pipe';

@NgModule({
  declarations: [SimulatorCardComponent, PillButtonComponent, BrandAssetPipe],
  imports: [CommonModule],
  exports: [SimulatorCardComponent, PillButtonComponent, BrandAssetPipe],
})
export class SharedModule {}
